import { WidgetTitle as LibWidgetTitle } from '@elfsight/widget-ui';
import { useLayoutGap } from '../layout';
import { Tabs } from '../tabs';
import { useSocialFeedSettings } from '../utils';

export function WidgetTitle() {
  const {
    widgetTitle,
    widgetTitleTitle,
    widgetTitleCaption,
    widgetTitleAlignment,
    widgetTitleTitleColor,
    widgetTitleCaptionColor,
    widgetTitleLinksColor,
    widgetTitleTitleTextStyle,
    widgetTitleCaptionTextStyle
  } = useSocialFeedSettings();

  const { gap: layoutGap, minGap } = useLayoutGap();

  return (
    <>
      <LibWidgetTitle
        enabled={widgetTitle}
        title={widgetTitleTitle}
        caption={widgetTitleCaption}
        titleColor={widgetTitleTitleColor}
        captionColor={widgetTitleCaptionColor}
        linksColor={widgetTitleLinksColor}
        alignment={widgetTitleAlignment}
        titleTextStyle={widgetTitleTitleTextStyle}
        captionTextStyle={widgetTitleCaptionTextStyle}
        bottomOffset={Math.max(layoutGap, minGap)}
      />

      <Tabs />
    </>
  );
}
